import { tagGQLFields } from '../post/tag.fields.js';
export function highlightedTagGQLFields(fields) {
    return `
    ${tagGQLFields(fields)}
  `;
}
